import { PROGRAM_TYPES, PROGRAM_SUB_TYPES } from "@tailormed/common-client/constant/assistanceProgram";

// Legacy PIDs not yet migrated to Manufacturer + Support subtype in backoffice.
// TODO(MVP-29891): remove LEGACY_SUPPORT_PIDS + the PID fallback branch in
// isSupportProgram once these APs have been updated:
//   - Verzenio Ongoing Support (Lilly)
//   - Austedo Support Program - Teva Neuroscience (Teva)
//   - Austedo Teva Total Support (Teva)
const LEGACY_SUPPORT_PIDS = [
  "Verzenio Ongoing Support",
  "Austedo Support Program - Teva Neuroscience",
  "Austedo Teva Total Support"
];

export const isSupportProgram = (programOrPotentialSaving) => {
  if (!programOrPotentialSaving) return false;
  const { programType, programSubtypes, pid, assistanceProgramPid } = programOrPotentialSaving;
  if (programType === PROGRAM_TYPES.Manufacturer && programSubtypes?.includes(PROGRAM_SUB_TYPES.Support)) {
    return true;
  }
  return LEGACY_SUPPORT_PIDS.includes(pid ?? assistanceProgramPid);
};
